import React from 'react';
import { Book } from '@/components/Icons/Book';
import { Calendar } from '@/components/Icons/Calendar';
import { CircleClock } from '@/components/Icons/CircleClock';
import { Door } from '@/components/Icons/Door';
import { LessonDetailsChip } from '@/components/LessonDetailsModal/LessonDetailsChip';
import type { LessonHeading } from '@/types/diary';
import { formatWeekdayDayMonth } from '@/utils/date';

interface Props {
  heading: LessonHeading;
  isEvaluation?: boolean;
}

export const MobileLessonTitle: React.FC<Props> = ({
  heading,
  isEvaluation = false,
}) => (
  <div className="flex flex-col gap-3 md:hidden">
    <div className="flex items-center gap-2">
      <span className="text-title-24 flex size-7 shrink-0 items-center justify-center rounded-full bg-on-primary-surface text-foreground">
        {heading.lessonNumber ?? (
          <Book className="size-4 text-subtle-foreground" />
        )}
      </span>
      <h1 className="min-w-0 truncate text-[24px]/[30px] font-semibold text-foreground">
        {heading.title}
      </h1>
    </div>

    <div className="flex flex-wrap items-center gap-2">
      <LessonDetailsChip
        icon={
          <>
            {isEvaluation && (
              <Calendar className="size-[15px] shrink-0" strokeWidth="1.2" />
            )}
            {!isEvaluation && (
              <CircleClock className="size-[15px] shrink-0" strokeWidth="1.2" />
            )}
          </>
        }
        label={formatWeekdayDayMonth(heading.date)}
      />
      {!!heading.roomNumber && (
        <LessonDetailsChip
          icon={<Door className="size-[15px] shrink-0" strokeWidth="1.2" />}
          label={heading.roomNumber}
        />
      )}
    </div>
  </div>
);
